// extracted by mini-css-extract-plugin
var _1 = "JQMVx";
var _2 = "KE6LU";
export { _1 as "base", _2 as "header" }
